export default __webpack_public_path__ + "static/media/4t.8bc1b574.jpg";